import React from 'react';
import { render } from 'react-dom';
import { combineReducers } from 'redux';
import { Provider } from 'react-redux';
import { Router, browserHistory } from 'react-router';
import { routerReducer, syncHistoryWithStore } from 'react-router-redux';

import { getUserInfo } from 'Utils';
import getDomainConfig from "@/domain/index"
import reducers from './reducers/reducer';
import configureStore from './store';
import routes from './routes';

// 传入reducer获取store
const store = configureStore(
  combineReducers({
    ...reducers,
    routing: routerReducer,
  }),
);

// 这里使用了html5的browserHistory， 而不是hash路由
// 同步history路由到redux的store中
const history = syncHistoryWithStore(browserHistory, store);

getDomainConfig(() => {
  if (window.top !== window) {
    getUserInfo();
  }
  render(
    <Provider store={store}>
      <Router history={history} routes={routes} />
    </Provider>,
    document.getElementById("root")
  );
});
